<template>
  <div  style="position: absolute;left: 0; top: 0; background-color: #f3f3f3; z-index: 1500;">
    <div style="display: flex; align-items: center; width: 100vw; min-height: 100vh;" id="cont_main">
          <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-3 m-0">
                  <div class="card-header no-border">
                      <div class="card-title text-xs-center">
                          <div class="p-1">
                            <img style="max-width: 70%; min-width: 50%;" src="../assets/pictures/me_logo.png" alt="branding logo">
                            <ul class="nav navbar-nav float-xs-right">  
                              <li class="dropdown dropdown-language nav-item">
                                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">                                
                                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>                                
                                </a>                                
                                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                                  <a class="dropdown-item" :id="lang" v-for="(lang, index) in $i18n.availableLocales" :key="index" @click="changeLanguage(lang)">
                                    <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>                          
                      </div>                      
                      <h6 class="card-subtitle line-on-side text-muted text-xs-center font-small-3">
                        <span v-if="!register">{{$t('login.lbl.login')}}</span>
                        <span v-if="register">{{$t('registr.lbl.reg') + ' ' + $t('titles.roles.' + dataRegistr.role)}}</span>
                      </h6>
                  </div>
                  <div class="card-body collapse in">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">
                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataAuthorization.user.$error }" >
                                <input type="text" v-model.trim="$v.dataAuthorization.user.$model"  class="form-control form-control-lg input-lg" id="user-name" :placeholder="$t('users.table.login')" >
                                <div class="form-control-position">
                                    <i class="icon-head"></i>
                                </div>
                                <div class="error" v-if="!$v.dataAuthorization.user.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.dataAuthorization.user.minLength">{{$t('errors.minLength')}} {{$v.dataAuthorization.user.$params.minLength.min}} </div>
                            </fieldset>
                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataAuthorization.password.$error }">
                                <input type="password" v-model.trim="$v.dataAuthorization.password.$model" class="form-control form-control-lg input-lg" id="user-password" :placeholder="$t('login.lbl.password')">
                                <div class="form-control-position">
                                    <i class="icon-key3"></i>
                                </div>
                                <div class="error" v-if="!$v.dataAuthorization.password.required">{{$t('errors.required')}}</div>
                                <!-- <div class="error" v-if="!$v.dataAuthorization.password.minLength">{{$t('errors.minLength')}} {{$v.dataAuthorization.password.$params.minLength.min}} </div> -->
                            </fieldset>
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.password2.$error }">
                                <input type="password" v-model.trim="$v.dataRegistr.password2.$model"  class="form-control form-control-lg input-lg" id="user-password2" :placeholder="$t('registr.lbl.confirmPass')">
                                <div class="form-control-position">
                                    <i class="icon-key3"></i>
                                </div>
                                <div class="error" v-if="!$v.dataRegistr.password2.required">{{$t('errors.required')}}</div>
                                
                            </fieldset>
                            
                                <!-- <fieldset class="form-group position-relative has-icon-left mb-otstup text-md-right" v-if="!register">
                                  <router-link :to="{ name: 'recoveryPaasword'}" class="card-link">
                                    <i class="icon-lock"></i> <span class="menu-title">{{ $t('titles.forgotPasswrd') }}</span>
                                  </router-link>
                                </fieldset> -->
                             
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.email.$error }">
                                <input type="text" v-model.trim="$v.dataRegistr.email.$model" class="form-control form-control-lg input-lg" :placeholder="$t('registr.lbl.email')">
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <div class="error" v-if="!$v.dataRegistr.email.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.dataRegistr.email.email">{{$t('errors.email')}}</div>
                            </fieldset>
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.username.$error }">
                                <input type="text" v-model.trim="$v.dataRegistr.username.$model" class="form-control form-control-lg input-lg" :placeholder="$t('registr.lbl.pib') " >
                                <div class="form-control-position">
                                    <i class="icon-head"></i>
                                </div>
                                <div class="error" v-if="!$v.dataRegistr.username.required">{{$t('errors.required')}}</div>
                            </fieldset>
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.phone.$error }">
                                <input type="text" id="contact" v-mask="'(###) ##-##-###'" class="form-control form-control-lg input-lg" :placeholder="$t('users.table.phone')" v-model.trim="$v.dataRegistr.phone.$model">
                                <div class="form-control-position">
                                  <i class="icon-address-book" ></i>
                              </div>
                              <div class="error" v-if="!$v.dataRegistr.phone.required">{{$t('errors.required')}}</div>
                            </fieldset>                      
                            
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                              <div class="col-md-6 edprou">
                                  <input type="text" id="edrpo" v-mask="'############'" autocomplete="off" class="form-control form-control-lg input-lg" :placeholder=" $t('registr.lbl.edrpo')" @change="findClient()"  v-model.trim="dataRegistr.edrpo" >
                                <div class="form-control-position">
                                  <!--<button type="button" class="btn btn-auth btn-sm" @click="findClient()"><i class="icon-search4" ></i></button>-->
                                  <a @click="findClient()"><i class="icon-search4" ></i></a>
                              </div>
                              </div>
                              <div class="col-md-6 inn">
                                  <input type="text" id="edrpo" v-mask="'############'" autocomplete="off" class="form-control form-control-lg input-lg" :placeholder=" $t('registr.lbl.ipn')" @change="findClient()" v-model.trim="dataRegistr.ipn" >
                                <div class="form-control-position">
                                  <!--<button type="button" class="btn btn-auth btn-sm" @click="findClient()"><i class="icon-search4" ></i></button>-->
                                  <a @click="findClient()"><i class="icon-search4" ></i></a>
                              </div>
                              </div>
                                
                             
                            


                            
                            </fieldset>
                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.nameClient.$error }">
                                <input type="text" v-model.trim="$v.dataRegistr.nameClient.$model" class="form-control form-control-lg input-lg" :placeholder=" $t('registr.lbl.organization')">
                                <div class="form-control-position">
                                    <i class="icon-bank"></i>
                                </div>
                                <div class="error" v-if="!$v.dataRegistr.nameClient.required">{{$t('errors.required')}}</div>
                            </fieldset>
                            <fieldset v-show="register && !registerAsClient"  :class="{ 'form-group--error': $v.dataRegistr.pdv.$error }">
                              <div class="form-group" >
                                <label class="text-bold-600" for="issueinput5">{{$t('tender.label.PDV')}}</label>
                                <select v-model="dataRegistr.pdv" id="issueinput5" name="priority" class="form-control" data-toggle="tooltip" data-trigger="hover" data-placement="top" data-title="Priority" data-original-title="" title="">
                                   <option value=null selected ></option>
                                    <option value=true>{{$t('registr.lbl.yes')}}</option>
                                    <option value=false>{{$t('registr.lbl.no')}}</option>                               
                                </select>
                              </div>
                              <div class="error" v-if="!$v.dataRegistr.pdv.required">{{$t('errors.required')}}</div>
                            </fieldset>



                            <!-- <fieldset v-show="register" class="checkboxsas">
                              <label>
                                <input type="checkbox" v-model="dataRegistr.pdv" @click="dataRegistr.pdv = !dataRegistr.pdv" value="">
                                <b>{{$t('tender.label.PDV')}}</b>
                              </label>
                          </fieldset> -->
                            <fieldset v-show="register && !registerAsClient" class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.typeOfdelivery }">
                              <label class="text-bold-600"> {{$t('tender.label.trType')}} </label>  
                            </fieldset>
                            
                            <fieldset v-show="register && !registerAsClient"  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.typeOfdelivery }">  
                                                     
                              <label>
                                <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.auto">
                               {{$t('tender.trType.1')}}
                              </label> 
                              <label>
                                <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.jd">
                                {{$t('tender.trType.3')}}
                              </label>   
                              <label>
                                <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.avia">
                               {{$t('tender.trType.2')}}
                              </label>                      
                              <label>
                                <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.sea">
                                {{$t('tender.trType.4')}}
                              </label>                      
                            </fieldset>
                            <fieldset v-show="register && !registerAsClient" class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.directionOfdelivery }" >
                              <label class="text-bold-600"> {{$t('tender.label.trDirection')}} </label>  
                            </fieldset>
                             <fieldset v-show="register && !registerAsClient" class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.directionOfdelivery }">                                                       
                              <label>
                                <input type="checkbox" value="1" v-model="dataRegistr.directionOfdelivery.internal">
                                 {{$t('tender.direction.1')}}
                              </label> 
                              <label>
                                <input type="checkbox" value="2" v-model="dataRegistr.directionOfdelivery.exsternal">
                                {{$t('tender.direction.2')}}
                              </label>
                                                   
                            </fieldset>
                            

                            <fieldset v-show="register " class="form-group position-relative has-icon-left">                                
                                <input type="file" name="file" id="file" class="inputfile" @change="onUploadImg"/>
                                <center>
                                  <a>{{$t('registr.lbl.logo')}}</a>
                                  <label id="file_loader" for="file"><a class="btn btn-warning btn-min-width">
                                    <i class="icon-upload3"></i> {{ $t('tasks.buttons.file') }}</a>
                                  </label>
                                </center>
                            </fieldset>
                            

                            <!--<div class="img_cont" >
                              <img :src="image.data" class="img_cont">
                            </div>-->
                            <div class="col-md-12 mt-1" v-if="register">
                                <div style="display: flex; justify-content: center;">
                                    <div class="hand" style="max-width: 60%; position: relative; margin-right: 1%; margin-top: 1%;" @click="image = {name: null, data: null}">
                                        <img v-bind:src="image.data" style="width:100%" />
                                    </div>
                                </div>
                            </div>

                            <button v-if="!register" ref="login" type="button" class="btn btn-auth btn-lg btn-block" @click="checkForm()"><i class="icon-unlock2"></i> {{ $t('login.btn.login') }}</button>
                            <button v-else type="button" class="btn btn-auth btn-lg btn-block"  @click="checkForm()"><i class="icon-unlock2"></i> {{ $t('registr.btn.reg') }}</button>
                          </div>
                      </div>
                  </div>
                  <div class="card-footer">
                      <div class="">
                          <p v-if="!register" class="float-sm-right text-xs-center m-0">
                            {{ $t('registr.lbl.not_existing')}} : <span class="ex-btn">
                              <button type="button" class="btn btn-auth btn-sm" @click="register = true; registerAsClient = true; dataRegistr.role = $store.state.roles[0].val">{{ $t('registr.lbl.regCl')}}</button>
                              {{$t('registr.lbl.or')}}
                              <button type="button" class="btn btn-auth btn-sm" @click="register = true; registerAsClient = false; dataRegistr.role = $store.state.roles[3].val">{{ $t('registr.lbl.regServ') }}</button>
                            </span>
                          </p>  
                          <p v-else class="float-sm-right text-xs-center m-0">{{ $t('registr.lbl.existing') }} ? 
                            <button type="button" class="btn btn-auth btn-sm" @click="register = false" > {{ $t('login.lbl.login') }}</button>
                          </p>
                           <!-- <p class="typo__p" v-if="submitStatus === 'ERROR'">{{ $t('errors.confirm') }}</p> -->
                      </div>
                  </div>
              </div>
          </div>

      </div>

  </div>
</template>

<script>
import { required, minLength,  sameAs, email, requiredIf } from 'vuelidate/lib/validators'
    export default {
      name: "Login",
      components: {},
      data() {
          return {  
            registerAsClient:false,          
            image: {name: null, data: null},
            errors: [],
            error:{
              directionOfdelivery: false,
              typeOfdelivery:false
            },
            submitStatus:null,
            dataAuthorization: {
                user: null,
                password: null,
                ip: null,
            },
            dataRegistr: {
              password2: null,
              username: null,
              role: '',
              phone: null,
              email: null,
              edrpo: null,
              ipn:null,
              nameClient: null,
              guidClient: null,
              logo_organization: null,
              type: "1",
              pdv:null,
              typeOfdelivery:{
                auto:false,
                jd:false,
                avia:false,
                sea:false
              },
              directionOfdelivery:{
                internal:false,
                exsternal:false
              }
              
            },
            register: false,            
          };
        },
        validations: {
        dataAuthorization:{
            user:{
                required,
                minLength: minLength(4)
            },
            password:{
                required,
                minLength: minLength(8)
            }
        },
        dataRegistr:{
          password2:{            
            required            
          },
          email:{
            required,
            email            
          },
          username:{
            required                       
          },
          phone:{
            required                       
          },
          edrpo:{
            required                       
          },
          nameClient:{
            required                       
          },
          pdv:{
            required 
          }
                  
        },
        
    },
        methods: {
          // addMessagestoStore(){            
          //   this.$store.commit('setUserMessages', messages);
          // },
          Login() {
              // this.getPermisionForPush();
              this.dataAuthorization.ip = '';
              
              window.localStorage.clear();

              localStorage.removeItem('reloaded');

              if (this.dataAuthorization.password.length > 0) {
                this.makeQuery("/portal/loginTender", { dataAuthorization: this.dataAuthorization })
                .then(res => {                 
                    if(res.data != null){
                      if(res.data.error != undefined){
                        this.showNotification('custom-error','Error',this.$t(`errors.login.${res.data.cod}`));
                      } else {

                        this.$store.state.guidUser = res.data.userGuid;
                        this.$store.state.login = res.data.username;
                        this.$store.state.userName = res.data.name;
                        this.$store.state.userToken = res.data.session;
                        this.$store.state.user = JSON.stringify(res.data.username);
                        this.$store.state.email = res.data.email;
                        this.$store.state.clientName = JSON.stringify(res.data.clientName);
                        this.$store.state.guidClient = res.data.clientGuid;
                        this.$store.state.clientEdrpo = res.data.clientEdrpo;
                        this.$store.state.ip = this.dataAuthorization.ip;
                        this.$store.commit('setCurrentUser', res.data.clientGuid);                        
                          if (res.data.vat ) {
                            this.$store.commit('setUserPdv', res.data.vat);
                            localStorage.setItem('pdv', res.data.vat);
                            }
                          // else {
                          //   this.$store.commit('setUserPdv', true)
                          //   localStorage.setItem('pdv', true);
                          // }
                        
                        // this.$store.state.pdv = this.dataAuthorization.vat || false;

                        // for (let i = 0; i < res.data.roles.length; i++) {
                        //   if(res.data.roles[i] == "dispatcher"){this.$store.state.listRole.dispatcher = true;}
                        //   else if(res.data.roles[i] == "admin"){this.$store.commit('setUserRoleAdmin', true);}
                        //   else if(res.data.roles[i] == "client"){this.$store.commit('setUserRoleClient', true);}
                        //   else if(res.data.roles[i] == "clientME"){this.$store.commit('setUserRoleUser', true);}
                        //   else if(res.data.roles[i] == "service"){this.$store.state.listRole.service = true;}
                        //   else if(res.data.roles[i] == "serviceOrg"){this.$store.state.listRole.serviceOrg = true;}
                        //   else if(res.data.roles[i] == "logist"){this.$store.commit('setUserRoleLogist', true);}
                        // }
                        if (res.data.roleAdmin == true){
                          this.$store.commit('setUserRoleAdmin', true);
                          this.$store.commit('setUserRole', "admin");
                        }
                        if (res.data.roleClient == true){
                          this.$store.commit('setUserRoleClient', true);
                          this.$store.commit('setUserRole', "client");
                        }
                        if (res.data.roleClientME == true){
                          this.$store.commit('setUserRoleUser', true);
                          this.$store.commit('setUserRole', "clientME");
                        }
                         if (res.data.roleLogist == true){
                        this.$store.commit('setUserRoleLogist', true);
                        this.$store.commit('setUserRole', "logist");
                        }
                        
                        localStorage.setItem('ip', this.dataAuthorization.ip);
                        if (res.data.vat ) {                            
                            localStorage.setItem('pdv', res.data.vat);
                          }
                          
                        localStorage.setItem('user',  JSON.stringify(res.data.username));
                        localStorage.setItem('userGuid',       res.data.userGuid);
                        localStorage.setItem('email',       res.data.email);
                        localStorage.setItem('username',       res.data.username);
                        localStorage.setItem('user-token', res.data.session);
                        localStorage.setItem('role',       this.$store.getters.getUserRole);
                        localStorage.setItem('clientName',  JSON.stringify(res.data.clientName));
                        localStorage.setItem('clientEdrpo',       res.data.clientEdrpo);
                        localStorage.setItem('guidClient',       res.data.clientGuid);
                        localStorage.setItem('name',       res.data.name);
                        
                        if ( this.isValid(res.data.image) ){
                          localStorage.setItem('profileImg', "data:image/jpg;base64," + res.data.image);
                          this.$store.commit('setProfilePhoto',"data:image/jpg;base64," + res.data.image);
                        }

                        
                        if (this.$store.state.userToken != null) { 
                          this.$emit('loggedIn')
                          if (this.$route.params.nextUrl != null) {
                            this.$store.state.isLoading = false;
                            this.$router.push(this.$route.params.nextUrl);
                          } else {
                            this.$store.state.isLoading = false;
                            //this.$router.push('dashboard');
                            //this.$router.go(1);
                            this.$router.push({ name: 'dashboard-layout'});
                          }
                        }
                      }
                    }
                    else {
                       this.showNotification('custom-error','Authorization','Wrong password ');
                    }
                });
              }
          },
          Registration() {
            let dataRequest = {
                //userGuid: "",
                username: this.dataRegistr.username,
                login: this.dataAuthorization.user,
                password: this.dataAuthorization.password,
                email: this.dataRegistr.email,
                edrpo: this.dataRegistr.edrpo,
                guidClient: this.dataRegistr.guidClient,
                nameClient: this.dataRegistr.nameClient,
                tel: this.dataRegistr.phone,
                type: "1",
                Novat: this.dataRegistr.pdv || false,
                role: this.dataRegistr.role,
                photo: null,
                typeOfdelivery:this.dataRegistr.typeOfdelivery,
                directionOfdelivery:this.dataRegistr.directionOfdelivery,
                system: "1"
            };         
          
            if (this.isValid(this.image.data)){
              let img = (this.image.data).split(',');
              dataRequest.photo = img[1];
            }
            if (this.registerAsClient) {
              dataRequest.role = "clientME" 
            }
            this.makeQuery("/portal/registrationUserTender", {dataRequest: dataRequest})
            .then(res => {
                if(res != null){
                  this.showNotification('custom-success','Registration','Successfully registered ' + this.dataAuthorization.user);
                  this.register = false;
                }
            });
          },
          findClient(){
            if ( this.isValid(this.dataRegistr.edrpo) || this.isValid(this.dataRegistr.ipn)){
              //this.listClients = [];
              console.log("valid")
              
              let dataRequest = {};
              if(this.dataRegistr.edrpo && this.dataRegistr.edrpo.length > 4 ){
                dataRequest.edrpo = this.dataRegistr.edrpo
              }
              if (this.dataRegistr.ipn && this.dataRegistr.ipn.length > 4){
                dataRequest.edrpo =  "",
                dataRequest.inn = this.dataRegistr.ipn
              }
               console.log(dataRequest);
              if (dataRequest.edrpo || dataRequest.inn){
                
                this.makeQuery("/service/getClient", {dataRequest: dataRequest})
                .then(result => {
                    console.log(result)
                  //this.listClients = result;
                  this.dataRegistr.guidClient = result.data.data.guidClient;
                  this.dataRegistr.nameClient = result.data.data.name;
                  console.log(result.data.guidClient)
                  if(this.isValid(this.dataRegistr.nameClient) == false){
                    this.dataRegistr.nameClient = null;
                    this.dataRegistr.guidClient = null;

                    this.showNotification('custom-info','Search','Client not found!');
                  } else {
                    this.showNotification('custom-success','Search','Found client!');
                  }
                });

              }
            }
          },
          onUploadImg(e){
            if (e.target.files.length > 0){
              for (let i = 0; i < e.target.files.length; i++) {
                const element = e.target.files[i];
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = e => {
                  //this.images.push({name: element.name, data: e.target.result});
                  this.image = {name: element.name, data: e.target.result};

                };                        
              }
            }
          },
          checkForm(){
            this.$v.$touch()
            if (this.$v.$invalid) {
              this.submitStatus = 'ERROR'
            }
            this.errors = [];
            if (!this.dataAuthorization.user){ this.errors.push('Login can not be empty!'); }
            if ( !this.isValid(this.dataAuthorization.password) ){
              this.errors.push('Password can not be empty!');
            }
            if (this.register){
              if (!this.dataRegistr.username){ this.errors.push('Name of user can not be empty!'); }
              if (!this.dataRegistr.phone){ this.errors.push('Phone can not be empty!'); }
              if (!this.dataRegistr.email){ this.errors.push('E-Mail can not be empty!'); }             
              if ( !this.isValid(this.dataRegistr.password2) ){ this.errors.push('Confirmation password can not be empty!'); }
              if (this.dataAuthorization.password != this.dataRegistr.password2){ this.errors.push('Passwords does not match'); }
              if (!this.registerAsClient && this.errorInDelivery) {this.error.typeOfdelivery = true; this.errors.push('Вкажіть вид перевезення!'); }
              if (!this.registerAsClient && this.errordirectionOfdelivery) {this.error.directionOfdelivery = true; this.errors.push('Вкажіть напрямок перевезення!');} 
              if ( !this.isValid(this.dataRegistr.guidClient) ){
                 if (!this.dataRegistr.edrpo){//if ((!this.dataRegistr.edrpo) && (!this.dataRegistr.nameClient)){
                  this.errors.push('Organization can not be empty!');
                }          
              }
            }
            if (this.errors.length > 0 || this.register && !this.registerAsClient && this.errorInDelivery || this.register && !this.registerAsClient && this.errordirectionOfdelivery ){
               if (!this.registerAsClient && this.errorInDelivery) {
                this.error.typeOfdelivery = true                
                this.errors.push('Вкажіть вид перевезення!');               
              }
              if (!this.registerAsClient && this.errordirectionOfdelivery) {
                this.error.directionOfdelivery = true                
                this.errors.push('Вкажіть напрямок перевезення!');              
              }
              for (let i = 0; i < this.errors.length; i++) {
                this.showNotification('custom-error','Error',this.errors[i]);
              }
              
            } else {
              if (this.register ){
                this.Registration();
              } else {
                this.Login();
              }
            }
          },
         
        },
        computed:{
          
        errordirectionOfdelivery(){
           return !this.dataRegistr.directionOfdelivery.internal && !this.dataRegistr.directionOfdelivery.exsternal  ? true : false       
        },

        errorInDelivery(){
           return !this.dataRegistr.typeOfdelivery.auto && !this.dataRegistr.typeOfdelivery.jd && !this.dataRegistr.typeOfdelivery.avia && !this.dataRegistr.typeOfdelivery.sea ? true : false }        
        },
        watch:{},
        mounted () {
           localStorage.removeItem('profileImg');
          //  this.addMessagestoStore();
        }
    }
</script>

<style scoped>

.img_cont{
  max-width: 60%;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
 .form-group__message, .error {
    font-size: 0.75rem;
    line-height: 1;
    display: none;
    /* margin-left: 14px; */
    margin-top: 0.6875rem;
    margin-bottom: 0.9375rem; }
.form-group--alert,
  .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out; }
  
    .form-group--success .form__label, .form-group--success .form__label--inline {
    color: #43AC6A; }
  
  .form-group--success .form-group__addon {
    color: white;
    border-color: #85d0a1;
    background: #85d0a1; }
  
  .form-group--success input,
  .form-group--success textarea,
  .form-group--success input:focus,
  .form-group--success input:hover {
    border-color: #85d0a1; }
  
  .form-group--success + .form-group__message, .form-group--success + .error {
    display: block;
    color: #73c893; }
  
  .form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label{
    color: #f04124; 
    display: block;
    }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error  .error  {
    display: block;
    color: #f57f6c; }
    .form-group--error label {    
    color: #f57f6c; }
  
  .form-group--alert .form__label, .form-group--alert .form__label--inline {
    color: #f08a24; }
  
  .form-group--alert .form-group__addon {
    color: white;
    border-color: #f7bd83;
    background: #f7bd83; }
  
  .form-group--alert input,
  .form-group--alert textarea,
  .form-group--alert input:focus,
  .form-group--alert input:hover {
    border-color: #f7bd83; }
  
  .form-group--alert + .form-group__message {
    display: block;
    color: #f5b06c; }
  #cont_main{
  background-image: url('../assets/pictures/tender-bagr.jpg');
  background-color: rgba(255,255,255,0.5); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
.edprou {
  padding-left: 0px;
  padding-right:5px ;
  padding-bottom: 5px;
}
.inn {
  padding-left: 5px;
  padding-right: 0px ;
}
.card-block {
  padding: 10px;
}
@media only screen and (max-width: 800px) {
.inn {
   padding-left: 0px;
}
.ex-btn {
  display: block;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue